"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "11", height: "13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 2.5a2.5 2.5 0 11-4.999.001A2.5 2.5 0 015 2.5zM.884 12.82l-.768-.64 10-12 .768.64-10 12zM8.5 13a2.5 2.5 0 10.001-4.999A2.5 2.5 0 008.5 13zM4 2.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM8.5 9a1.5 1.5 0 110 3 1.5 1.5 0 010-3z", fill: "#404040" }))); };
exports.default = Component;
//# sourceMappingURL=Percent.js.map